import React, {Component} from 'react';
//CSS
import '../LandingSubcomponents/QuienesSomos.css';

class QuienesSomos extends Component {
    render() {

        return (
            <div id="quienessomos">
                <div className="quienes-somos">
                    <h3 className="wow animated fadeIn" data-wow-duration="1.5s">
                        ¿Quiénes somos?
                    </h3>
                    <h4 className="wow animated fadeIn" data-wow-duration="1s" data-wow-delay=".5s">
                        M&F Distribuciones SRL es una empresa argentina especializada en la distribución de
                        productos de consumo masivo, apoyándonos en la experiencia que nos dan más de 25 años de
                        trayectoria proveyendo una variedad de productos de marcas reconocidas en el mercado
                        potenciando a cada uno de nuestros 5.000 clientes.
                        Estamos enteramente comprometidos en brindar un servicio de excelencia en ventas, es por
                        eso que contamos con personal perfectamente especializado en el rubro para satisfacer
                        las necesidades de cada uno de nuestros clientes brindando atención personalizada a
                        través de nuestro call center.
                    </h4>
                </div>
            </div>
        );
    }
}


export default QuienesSomos;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/QuienesSomos.js